import React from 'react'
import BaseBtn from './BaseBtn'
import { useDelete } from '../../../../../api/hooks'

const DeleteBtn = ({ id, api }) => {

    const { onDelete } = useDelete(api)

    return (
        <BaseBtn icon={"weui:delete-filled"} className='delete' reqAction={'canDelete'} onApply={() => onDelete(id)} />
    )
}

export default DeleteBtn